import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Grid2, Typography } from '@mui/material';

const useStyles = makeStyles((theme) => ({
	root: {},
}));

const Header = (props) => {
	const { module, view, actions, className, ...rest } = props;

	const classes = useStyles();

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<Grid2
				alignItems="flex-end"
				container
				justifyContent="space-between"
				spacing={3}
			>
				<Grid2 item>
					<Typography component="h2" gutterBottom variant="overline">
						{module}
					</Typography>
					<Typography component="h1" variant="h3">
						{view}
					</Typography>
				</Grid2>
				{actions
					&& (
						<Grid2 item>
							{actions}
						</Grid2>
					)}
			</Grid2>
		</div>
	);
};

Header.propTypes = {
	className: PropTypes.string,
	module: PropTypes.string,
	view: PropTypes.string,
	actions: PropTypes.object
};

Header.defaultProps = {};

export default Header;
